<template>
  <div class="" style="width: 100%; margin-bottom: 100px;">
         <v-row>
      <v-col>
    <v-container fluid>
      <v-row>
        <v-col class="d-flex flex-row align-center flex-wrap" style="gap: 8px;">
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h1 style="line-height: 26px; font-size: 26px; text-align: left;">{{serialNaming.singular}} Viewer</h1>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex flex-row flex-wrap align-center" style="gap: 8px;">
          <v-text-field style="max-width: 350px; flex: 1 1 250px;" label="Currently Viewing" @change="lookupSerial" dense outlined hide-details v-model="currentlyViewing"></v-text-field>
          <v-btn color="success" @click="lookupSerial">Search</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!loader && !currentState">
        <v-col>
          <h3>No {{serialNaming.singularLower}} could be found matching "{{ $route.params.id }}".</h3>
        </v-col>
      </v-row>
      <v-row v-if="currentState">
        <v-col cols="12" md="4">
          <v-card outlined>
            <v-card-title>Current State</v-card-title>
            <v-card-text class="d-flex flex-column" style="gap: 4px;">
              <div>
                {{serialNaming.singular}}: <b>{{ currentState.serial }}</b>
              </div>
              <div v-if="currentState.product">
                Product:
                <router-link :to="'/products/view/'+currentState.product.id">{{ currentState.product.name }}</router-link>
              </div>
              <div v-if="currentState.product && currentState.product.sku">
                SKU: <b>{{ currentState.product.sku }}</b>
              </div>
              <div>
                Current Location: <b>{{ lookupLocation(currentState.locationId) || '-' }}</b>
              </div>
              <div>
                Current Customer:
                <router-link v-if="currentState.customerId" :to="'/customers/view/'+currentState.customerId">{{ currentState.customerName || currentState.customerId }}</router-link>
                <span v-else>-</span>
              </div>
              <v-chip v-if="currentState.softDeleted" color="error" small>
                Soft Deleted {{ helpers.formatDate(currentState.softDeletedAt, 'withTime') }} by {{ lookupUsername(currentState.softDeletedBy) }}
              </v-chip>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="8">
          <v-card outlined>
            <v-card-title>History</v-card-title>
            <v-card-text>
              <h4 v-if="events.length === 0">No history events could be found for this {{serialNaming.singularLower}}.</h4>
              <v-timeline v-else class="ml-n7" dense clipped>
                <v-timeline-item
                    v-for="(item, index) in events"
                    :key="index"
                    small
                    fill-dot
                    :color="eventMeta(item.type).color"
                    :icon="eventMeta(item.type).icon"
                >
                  <v-alert
                      :value="true"
                      class="white--text d-flex flex-column"
                      style="gap: 2px;"
                      :color="eventMeta(item.type).color"
                      dense
                      small
                  >
                    <div style="font-size: 14px;">
                      <b>{{ item.title }}</b> <router-link v-if="item.documentLink" class="white--text" style="text-decoration: underline;" :to="item.documentLink">(View {{ formatDocType(item.documentType) }})</router-link>
                    </div>
                    <template v-if="item.type === 'manual_edit'">
                      <div v-if="item.locationId !== item.previousLocationId" style="font-size: 12px;">
                        Location: {{ lookupLocation(item.previousLocationId) || 'None' }} &rarr; {{ lookupLocation(item.locationId) || 'None' }}
                      </div>
                      <div v-if="item.customerId !== item.previousCustomerId" style="font-size: 12px;">
                        Customer:
                        <router-link v-if="item.previousCustomerId" class="white--text" style="text-decoration: underline;" :to="'/customers/view/'+item.previousCustomerId">{{ item.previousCustomerName || item.previousCustomerId }}</router-link>
                        <span v-else>None</span>
                        &rarr;
                        <router-link v-if="item.customerId" class="white--text" style="text-decoration: underline;" :to="'/customers/view/'+item.customerId">{{ item.customerName || item.customerId }}</router-link>
                        <span v-else>None</span>
                      </div>
                    </template>
                    <template v-else>
                      <div v-if="item.locationId" style="font-size: 12px;">Location: {{ lookupLocation(item.locationId) || '-' }}</div>
                      <div v-if="item.customerId" style="font-size: 12px;">
                        Customer:
                        <router-link class="white--text" style="text-decoration: underline;" :to="'/customers/view/'+item.customerId">{{ item.customerName || item.customerId }}</router-link>
                      </div>
                    </template>
                    <b style="font-size: 12px;">{{ item.userId ? lookupUsername(item.userId) : '' }} {{ item.userId ? 'at' : '' }} {{ helpers.formatDate(item.timestamp, 'withTime') }}</b>
                  </v-alert>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
      </v-col>
     </v-row>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<style scoped>
.spacedCard{
  padding: 20px;
  margin-bottom: 20px;
}
</style>

<script>
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import helpers from '../../plugins/helpers';
export default {
  components: {
  },
  data () {
    return {
      helpers: helpers,
      printers: [],
      loader: false,
      currentState: null,
      events: [],
      snackObj: {
        color: "",
        state: false,
        text: "",
      },
      currentlyViewing: null,
      eventMetaMap: {
        created: {icon: 'mdi-plus-circle', color: 'grey darken-1'},
        order_added: {icon: 'mdi-cart-plus', color: 'info'},
        order_sealed: {icon: 'mdi-cart-check', color: 'success'},
        order_voided: {icon: 'mdi-cart-remove', color: 'error'},
        rr_added: {icon: 'mdi-package-variant-plus', color: 'info'},
        rr_sealed: {icon: 'mdi-package-variant-closed-check', color: 'success'},
        rr_voided: {icon: 'mdi-package-variant-closed-remove', color: 'error'},
        return_added: {icon: 'mdi-keyboard-return', color: 'info'},
        return_sealed: {icon: 'mdi-check-circle', color: 'success'},
        it_sent: {icon: 'mdi-truck-fast', color: 'info'},
        it_received: {icon: 'mdi-truck-check', color: 'success'},
        it_voided: {icon: 'mdi-truck-remove', color: 'error'},
        dispatch: {icon: 'mdi-truck-delivery', color: 'info'},
        manual_edit: {icon: 'mdi-pencil', color: 'warning'},
      },
      docTypeLabels: {
        Order: 'Order',
        ReceivingReport: 'Receiving Report',
        Return: 'Return',
        InventoryTransfer: 'Inventory Transfer',
        Dispatch: 'Dispatch',
      },
    }
  },
  async mounted(){
    window.scrollTo({top: 0});
    this.currentlyViewing = this.$route.params.id
    await this.getAllData();
  },

  computed: {
    ...mapGetters(['getEndpoint', "isAllowed", 'getUser', 'getGlobalValue', 'scanBus', 'lookupUsername', 'lookupLocation', 'serialNaming']),
  },
  watch: {
    '$route.params.id': async function(){
      this.currentlyViewing = this.$route.params.id
      await this.getAllData();
    }
  },
  methods: {
    ...mapMutations([
      'lockGlobalQueryBc',
      'unlockGlobalQueryBc',
      'setScanBus',
      'resetScanBus',
    ]),
    eventMeta(type){
      return this.eventMetaMap[type] || {icon: 'mdi-help-circle', color: 'grey'};
    },
    formatDocType(type){
      return this.docTypeLabels[type] || type;
    },
    async lookupSerial(){
      await this.$router.push({path: `/products/serial/${this.currentlyViewing}`})
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.state = true;
      this.snackObj.color = color;
    },
    async getAllData(){
      try {
        this.loader = true
        this.currentState = null
        this.events = []
        let psid = this.$route.query.psid ? `?psid=${this.$route.query.psid}` : '';
        let res = await axios.get(`${this.getEndpoint}/api/products/serialHistory/${this.$route.params.id}${psid}`)
        if(res.data.error) throw res.data.error
        this.currentState = res.data.data.currentState
        this.events = res.data.data.events
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error")
      } finally {
        this.loader = false
      }
    },
  }
}
</script>
